import { render, staticRenderFns } from "./DeliveryPayLog.vue?vue&type=template&id=cb5b83d4&scoped=true"
import script from "./DeliveryPayLog.vue?vue&type=script&lang=js"
export * from "./DeliveryPayLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5b83d4",
  null
  
)

export default component.exports